import Contracts from '../collection/contracts';
import Clusters from '../collection/refbooks/clusters';
import Fields from '../collection/refbooks/fields';
import DataTables from '../collection/datatables';
import Locations from '../service/locations';
import Organizations from '../collection/organizations';
import Priorities from '../collection/priorities';
import Roles from '../collection/roles';
import Scripts from '../collection/refbooks/scripts';
import Servers from '../collection/refbooks/servers';
import ServiceObjectMappings from '../collection/service.object.mappings';
import Statuses from '../collection/statuses';
import Stickers from '../collection/refbooks/stickers';
import Types from '../collection/refbooks/types';
import TypeGroups from '../collection/type.groups';
import UserTypes from '../collection/refbooks/user.types';
import UserTags from '../collection/refbooks/user.tags';
import Workgroups from '../collection/refbooks/workgroups';





export default class Mod {

    constructor(options) {

    }

    init() {
        return !this.initialized_
            ? fetch.call( this )
            : Promise.resolve();
    }

    injectable() {
        return {
            datatables: this.datatables_,
            contracts: this.contracts_,
            clusters: this.clusters_,
            organizations: this.organizations_,
            types: this.types_,
            typeGroups: this.typeGroups_,
            statuses: this.statuses_,
            priorities: this.priorities_,
            fields: this.fields_,
            stickers: this.stickers_,
            roles: this.roles_,
            workgroups: this.workgroups_,
            scripts: this.scripts_,
            servers: this.servers_,
            userTypes: this.userTypes_,
            userTags: this.userTags_,
            locationService: this.locations_,
            serviceObjectMappings: this.serviceObjectMappings_,
        };
    }

}






function fetch() {
    return this.datatables_ = new DataTables(),
        this.contracts_ = new Contracts( { endpoint: 'contracts/list?apiVersion=2.0&limit=1000000' } ),
        this.clusters_ = new Clusters( { endpoint: 'clusters/list?apiVersion=2.0&limit=1000000' } ),
        this.organizations_ = new Organizations(),
        this.types_ = new Types(),
        this.typeGroups_ = new TypeGroups(),
        this.statuses_ = new Statuses(),
        this.priorities_ = new Priorities(),
        this.fields_ = new Fields(),
        this.stickers_ = new Stickers(),
        this.roles_ = new Roles(),
        this.workgroups_ = new Workgroups(),
        this.scripts_ = new Scripts(),
        this.servers_ = new Servers(),
        this.userTypes_ = new UserTypes(),
        this.userTags_ = new UserTags(),
        this.serviceObjectMappings_ = new ServiceObjectMappings( { endpoint: '/service-objects/mappings/list?apiVersion=2.0&limit=1000000' } ),
        this.locations_ = Locations,
        Promise.all( [
            Locations.ready(),
            this.datatables_.fetch(),
            this.contracts_.fetch(),
            this.clusters_.fetch(),
            this.organizations_.fetch(),
            this.types_.fetch().then( ({ array, collection }) =>
                collection.reset( array.sort( ({ name: tA, id: iA }, { name: tB, id: iB }) =>
                    tA.toLowerCase() < tB.toLowerCase() 
                        ? -1 
                        : tA.toLowerCase() > tB.toLowerCase() ? 1 : iA - iB ) ) ),
            this.typeGroups_.fetch(),
            this.statuses_.fetch(),
            this.priorities_.fetch(),
            this.fields_.fetch(),
            this.stickers_.fetch(),
            this.roles_.fetch(),
            this.workgroups_.fetch(),
            this.scripts_.fetch(),
            this.servers_.fetch(),
            this.userTypes_.fetch(),
            this.userTags_.fetch(),
            this.serviceObjectMappings_.fetch(),
        ] )
        .then( () => this.initialized_ = true );
}


// WEBPACK FOOTER //
// ./src/js/module/common.js